module.exports = "/_next/static/images/game-2-intro-tutorial-flashlight-uv-mode-08563a672d8b1fc9f4d269c83853a931.png";